import { usePageMeta } from 'src/hooks';
import { ResourceList } from 'src/components/Resource/List';
import { ResourceCard } from 'src/components/Resource/Card';

import { informationLinksItems } from './model';

export default function InformationLinks() {
  usePageMeta('Information Links');

  return (
    <div className="container mx-auto">
      <ResourceList>
        {informationLinksItems.map((item, index) => (
          <ResourceCard key={index} {...item} />
        ))}
      </ResourceList>
    </div>
  );
}
